<template>
  <v-container grid-list-xl fluid>
    <confirm ref="confirm"></confirm>
    <v-snackbar :timeout="3000" bottom right :color="snackbar.color" v-model="snackbar.show">
      {{ snackbar.text }}
      <v-btn dark flat @click.native="snackbar.show = false" icon>
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
    <v-card>
      <v-card-title>
        <span class="title">Órdenes de Compra Pendientes de Aceptar y Validadas - Mercado Público</span>
        <v-spacer></v-spacer>
          <v-btn
                            fab
                            dark
                            small
                           color="primary"
                           style="margin:0px"
                           @click="refresh()"
                          > 
                            <v-icon dark  >refresh</v-icon>
                          </v-btn>
      </v-card-title>
    </v-card>
    <v-layout row wrap>      
       
      <v-flex xs12>
        <v-card>
          <v-toolbar card dense color="transparent">
            
              <v-btn color="green" small dark flat @click="getOCDashboardExcel('RECEPCION CONFORME')">
              <v-icon>attach_file</v-icon>Descargar OC's Pendientes de Aceptar y Validadas
            </v-btn>
             <v-spacer />

               <v-text-field
                 v-model="search"
                append-icon="search"
                label="Buscar..."
                single-line
                hide-details
                 class="mb-2"
                 @change="refresh()"
            required
              ></v-text-field>
             <div class="text-xs-center" :style="{visibility: loadingValidacion ? 'visible' : 'hidden'}" >  
                <v-progress-circular  
                  indeterminate :size="20"
                  color="primary"  
                ></v-progress-circular>
             </div>
          </v-toolbar>
          <v-divider/>
         
          <v-card-text class="mt-0">            

            <v-data-table
               :headers="headers"
              :search="search"
              :items="detalleItems"
               :rows-per-page-items="rowsPerPageItems"
              :pagination.sync="pagination"
              :total-items="totalItems"
              :loading="loading"
              rows-per-page-text="Registros por página"
               no-results-text=""
              no-data-text=""
              class="elevation-1"        
            >
              <template v-slot:items="props">
                <td> <v-btn :color="calculaStatus(props.item.estadoGestion)" small dark  @click="irOC(props.item.codigo)" slot="activator">
                <v-icon>zoom_in</v-icon>
                {{ props.item.codigo }}
              </v-btn></td>
                
                <td  class="truncate">{{ props.item.nombre }}</td>

                <td>
                    {{ props.item.nombreOrganismo }}
                     

                </td>
                <td>
                    {{ props.item.regionUnidad }}
                     

                </td>
              
              
                <td>{{ getHumanDate(props.item.fechaEnvio) }}</td>
                <td>{{ props.item.tipo }}</td>
                <td>{{ props.item.tipoMoneda }}</td>
                <td>{{ props.item.totalFormat }}</td>
              </template>
              <template slot="pageText" slot-scope="props">
                Registros {{ props.pageStart }} - {{ props.pageStop }} de
                {{ props.itemsLength }}
              </template>
              <v-alert
                slot="no-results"
                :value="true"
                color="error"
                icon="warning"
              >Su busqueda "{{ search }}" no obtuvo resultados.</v-alert>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<style>
.comentariosHome {
  height: 260px;
  overflow-y: auto;
}
.comentarioStatusHome {
  height: 40px;
}
.comentarioStatusLineasHome.v-list--two-line .v-list__tile {
  height: 40px;
  margin-bottom: 3px;
}
.truncate {
  max-width:200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
<script>
//import LicitacionesService from "@/services/LicitacionesService";

import OrdenCompraService from "@/services/OrdenCompraService";
import Loader from "@/components/Loader";
import moment from "moment";
//import FiltrosService from "@/services/FiltrosService";
import VWidget from "@/components/VWidget";
import AppEvents from "@/eventBus";
//import LicitacionesItems from "@/components/LicitacionesItems";
export default {
  components: {
    VWidget,
    Loader
  },
  data: () => ({
    snackbar: {
      show: false,
      text: "",
      color: ""
    },
    search: null,
    searchPendienteAceptacion: null,
    searchCancelada: null,
    loading: false,
    loadingPendiente: false,
    loadingValidacion: false,
    loadingCancelada: false,
    /*
public long Id { get; set; }
        public string Codigo { get; set; }
        public DateTime? FechaEstado { get; set; }
        public string UsuarioGestion { get; set; }
        public string EstadoGestion { get; set; }
        public string Nombre { get; set; }
        public string NombreOrganismo { get; set; }
        public DateTime? FechaEnvio { get; set; }
        public string Tipo { get; set; }
        public string TipoMoneda { get; set; }
        public float? Total { get; set; }
        public string TotalFormat    
    
    */
    detallePendiente: [],
    detallePendienteServer: [],
    detalleCanceladas: [],
    detalleCanceladasServer: [],
    detalleItems: [], 
    rowsPerPageItems: [20, 50, 100],
    pagination: {
      page: 1,
      rowsPerPage: 20,
      sortBy: "fechaEnvio",
      descending: true
    },  
    totalItems: 0,      
    headers: [
      {
        text: "Código",
        align: "left",
        sortable: true,
        value: "codigo"
      },
      {
        text: "Nombre",
        align: "left",
        sortable: true,
        value: "nombre"
      },
      {
        text: "Nombre Organismo",
        align: "left",
        sortable: true,
        value: "nombreOrganismo"
      },
      {
        text: "Región",
        align: "left",
        sortable: true,
        value: "regionUnidad"
      },
      {
        text: "Fecha Envio",
        align: "left",
        sortable: true,
        value: "fechaEnvio"
      },
      {
        text: "Tipo OC",
        align: "left",
        sortable: true,
        value: "tipo"
      },
      {
        text: "Moneda",
        align: "left",
        sortable: true,
        value: "tipoMoneda"
      },
      {
        text: "Total",
        align: "left",
        sortable: true,
        value: "total"
      }, 
    ]
  }),
  methods: {
     getHumanDate (date)
    {
      if (!date) return '';
      if (date === '0001-01-01') return '';
      return  moment(date).format("DD-MM-YYYY HH:mm:ss");
    },
    findPendienteAceptacion()
    {
       var busqueda = this.searchPendienteAceptacion == null ? "" : this.searchPendienteAceptacion;
      this.detallePendiente = this.detallePendienteServer.filter(item => item.codigo.toUpperCase().includes(busqueda.toUpperCase()));
    },
    findCancelada()
    {
      var busqueda = this.searchCancelada == null ? "" : this.searchCancelada;
      this.detalleCanceladas = this.detalleCanceladasServer.filter(item => item.codigo.toUpperCase().includes(busqueda.toUpperCase()));
    },
    async refresh()
    {
      const response =  await this.getAllData();
    },
    irOC(codigo)
    {
       this.$router.push({
        name: "OrdenCompraDetalle",
        //params: { codigo: codigo },
        query: { codigo: codigo  }
      });
    },
    handleClick(item) {
      debugger;
    },
     
     calculaStatus(estado) {
      if (estado === "PENDIENTE ACEPTACION") {
        return "deep-purple darken-1";
      } else if (estado === "CANCELADA") {
        return "red";
      } else if (estado === "VALIDADA" || estado === "ACEPTADA" || estado === "RECEPCION CONFORME") {
        return "green";
      } else if (estado === "PENDIENTE VALIDACION") {
        return "blue darken-1";
      }else {
        return "grey";
      }
    },
     async getOCDashboardExcel(estado) {
      this.loadingValidacion = true;
      const response = await OrdenCompraService.getOCDashboardExcel(estado);
      this.loadingValidacion = false;
    },
    async getOCAceptadas()
    {
        let paging = this.pagination;
      let sort = paging.sortBy === null ? "fechaEnvio" : paging.sortBy;
      let direction =
        paging.descending === null
          ? " desc"
          : paging.descending === true
          ? " desc"
          : " asc";
      sort = sort + direction;
      let paginacion =
        "sort=" +
        sort +
        "&page=" +
        paging.page +
        "&pageSize=" +
        paging.rowsPerPage;

        debugger;
        this.loadingValidacion = true;
        var busqueda = (this.search == null ? '' : this.search);
      const response = await OrdenCompraService.getOCDashboardPaging(
        
        paginacion ,
        busqueda,
        "PENDIENTE ACEPTACION"
      )
        .then(r => {
          debugger;
          this.detalleItems = r.data.data;
          this.totalItems = r.data.totalCount;
          this.loadingValidacion = false;
        })
        .catch(r => {
          console.log(r.response);
        });
        /*
       this.loadingValidacion  = true;
      const response = await OrdenCompraService.getOCDashboard("PENDIENTE ACEPTACION").then(r => {
         debugger;
        
        this.detalleItems = r.data;
         this.loadingValidacion  = false;
      });
     
*/
    },
    async getOCCanceladas()
    {
       
      this.loadingCancelada  = true;
       const response = await OrdenCompraService.getOCDashboard("CANCELADA").then(r => {
   
         debugger;
        this.detalleCanceladasServer = r.data;
        var busqueda = this.searchCancelada == null ? "" : this.searchCancelada;
         if(busqueda.length > 0)
         {
            this.detalleCanceladas = this.detalleCanceladasServer.filter(item => item.codigo.toUpperCase().includes(busqueda.toUpperCase()));
         }
         else
         {
             this.detalleCanceladas = r.data;
         }
       
        
         this.loadingCancelada  = false;
      });
     

    },
    async getOCPendienteValidacion()
    {
       
      this.loadingValidacion  = true;
      const response = await OrdenCompraService.getOCDashboard("PENDIENTE VALIDACION").then(r => {
         debugger;
        
        this.detalleItems = r.data;
         this.loadingValidacion  = false;
      });
     

    },
    async getAllData()
    {
      const response = await this.getOCAceptadas();
             
    }
  },
  created()
  {

     AppEvents.$on('APP_REFRESH_DASHBOARD', (accion) => {
       console.log("ACTUALIZACION DASHBOARD " + accion.accion +" " + accion.codigo )
       const response = this.getAllData();
    });
  }
  ,
   mounted() {
     /*this.$refs.navidad
              .open("Saludo de navidad", "saludo de navidad", {
                color: "orange",
                width: 800
              })
              .then(confirm => {
                if (confirm) {
                   
                }
              });*/
              
              const response = this.getAllData();
  },
  
   watch: {
    pagination: {
      handler() {
        this.getAllData();
      },
      deep: true
    },
  }
};
</script>
